// backoffice/src/redux/slices/planning/planningThunks.js
// (Code Complet avec Thunk importCyclesBatch)

import { createAsyncThunk } from '@reduxjs/toolkit';
// Assurez-vous que le service planning est correctement importé
import * as planningService from '../../../services/planning.service';
import { message } from 'antd';

// --- Thunks pour les Cycles ---
export const fetchCycles = createAsyncThunk(
    'planning/fetchCycles',
    async (params, { rejectWithValue }) => {
        try {
            const response = await planningService.getCycles(params);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            message.error(error.response?.data?.message || 'Erreur chargement cycles.');
            return rejectWithValue(error.response?.data || 'Erreur inconnue');
        }
    }
);

export const createCycle = createAsyncThunk(
    'planning/createCycle',
    async (cycleData, { rejectWithValue }) => {
        try {
            const response = await planningService.addCycle(cycleData);
            message.success('Cycle créé !');
            return response.data;
        } catch (error) {
            message.error(error.response?.data?.message || 'Erreur création cycle.');
            return rejectWithValue(error.response?.data || 'Erreur inconnue');
        }
    }
);

export const updateCycle = createAsyncThunk(
    'planning/updateCycle',
    async ({ id, ...cycleData }, { rejectWithValue }) => {
        try {
            const response = await planningService.updateCycle(id, cycleData);
            message.success('Cycle mis à jour !');
            return response.data;
        } catch (error) {
            message.error(error.response?.data?.message || 'Erreur mise à jour cycle.');
            return rejectWithValue(error.response?.data || 'Erreur inconnue');
        }
    }
);

export const deleteCycle = createAsyncThunk(
    'planning/deleteCycle',
    async (id, { rejectWithValue }) => {
        try {
            await planningService.deleteCycle(id);
            message.success('Cycle supprimé.');
            return id;
        } catch (error) {
            message.error(error.response?.data?.message || 'Erreur suppression cycle.');
            return rejectWithValue(error.response?.data || 'Erreur inconnue');
        }
    }
);

// --- NOUVEAU THUNK : Importer Batch de Cycles (JSON) ---
/**
 * Envoie un tableau d'objets cycles (parsés depuis le CSV) au backend.
 * @param {Array<Object>} parsedCyclesData - Le tableau d'objets contenant les données des cycles.
 *        Chaque objet devrait avoir les clés attendues par le backend (ex: delegateEmail, nomCycle, etc.)
 */
export const importCyclesBatch = createAsyncThunk(
    'planning/importCyclesBatch', // Nom de type unique
    async (parsedCyclesData, { rejectWithValue }) => {
        try {
            console.log("[Thunk importCyclesBatch] Envoi des données JSON:", parsedCyclesData);
            // Appelle la nouvelle fonction de service qui envoie du JSON
            const response = await planningService.importCyclesJSON(parsedCyclesData);
            console.log("[Thunk importCyclesBatch] Réponse du service:", response.data);
            // Le backend doit retourner un résumé de l'opération
            return response.data;
        } catch (error) {
            console.error("[Thunk importCyclesBatch] Erreur interceptée:", error);
            message.error(error.response?.data?.message || 'Échec de l\'importation batch des cycles.');
            return rejectWithValue(error.response?.data || { message: 'Erreur inconnue lors de l\'importation batch.' });
        }
    }
);
// --- FIN NOUVEAU THUNK ---


export const fetchCyclesByDelegate = createAsyncThunk(
    'planning/fetchCyclesByDelegate',
    async (delegateId, { rejectWithValue }) => {
        if (!delegateId) {
            return [];
        }
        try {
            // On utilise la fonction de service existante `getCycles`
            // en lui passant le paramètre que le backend attend.
            const response = await planningService.getCycles({ delegateId: delegateId });
            return response.data;
        } catch (error) {
            message.error(error.response?.data?.message || 'Erreur chargement des cycles pour ce délégué.');
            return rejectWithValue(error.response?.data || 'Erreur inconnue');
        }
    }
);


// --- Thunks pour les Jours Fériés (inchangés) ---
export const fetchPublicHolidays = createAsyncThunk('planning/fetchPublicHolidays', async (_, { rejectWithValue }) => { try { const r=await planningService.getPublicHolidays(); return r.data; } catch (e) { message.error(e.response?.data?.message||'Err jours fériés.'); return rejectWithValue(e.response?.data); } });
export const createPublicHoliday = createAsyncThunk('planning/createPublicHoliday', async (d, { rejectWithValue }) => { try { const r=await planningService.addPublicHoliday(d); message.success('Jour férié créé!'); return r.data; } catch (e) { message.error(e.response?.data?.message||'Err création jour férié.'); return rejectWithValue(e.response?.data); } });
export const updatePublicHoliday = createAsyncThunk('planning/updatePublicHoliday', async ({id,...d}, { rejectWithValue }) => { try { const r=await planningService.updatePublicHoliday(id,d); message.success('Jour férié màj!'); return r.data; } catch (e) { message.error(e.response?.data?.message||'Err màj jour férié.'); return rejectWithValue(e.response?.data); } });
export const deletePublicHoliday = createAsyncThunk('planning/deletePublicHoliday', async (id, { rejectWithValue }) => { try { await planningService.deletePublicHoliday(id); message.success('Jour férié supprimé.'); return id; } catch (e) { message.error(e.response?.data?.message||'Err suppr jour férié.'); return rejectWithValue(e.response?.data); } });

// --- Thunks pour les Congés Délégués (inchangés) ---
export const fetchDelegateLeaves = createAsyncThunk('planning/fetchDelegateLeaves', async (p, { rejectWithValue }) => { try { const r=await planningService.getDelegateLeaves(p); return r.data; } catch (e) { message.error(e.response?.data?.message||'Err chargement congés.'); return rejectWithValue(e.response?.data); } });
export const createDelegateLeave = createAsyncThunk('planning/createDelegateLeave', async (d, { rejectWithValue }) => { try { const r=await planningService.addDelegateLeave(d); message.success('Congé créé!'); return r.data; } catch (e) { message.error(e.response?.data?.message||'Err création congé.'); return rejectWithValue(e.response?.data); } });
export const updateDelegateLeave = createAsyncThunk('planning/updateDelegateLeave', async ({id,...d}, { rejectWithValue }) => { try { const r=await planningService.updateDelegateLeave(id,d); message.success('Congé màj!'); return r.data; } catch (e) { message.error(e.response?.data?.message||'Err màj congé.'); return rejectWithValue(e.response?.data); } });
export const deleteDelegateLeave = createAsyncThunk('planning/deleteDelegateLeave', async (id, { rejectWithValue }) => { try { await planningService.deleteDelegateLeave(id); message.success('Congé supprimé.'); return id; } catch (e) { message.error(e.response?.data?.message||'Err suppr congé.'); return rejectWithValue(e.response?.data); } });